import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import DeleteZoneRule from 'src/features/membershipType/components/forms/zoneRule/DeleteZoneRule';
import UpdateZoneRuleFormModal from 'src/features/membershipType/components/forms/zoneRule/UpdateZoneRuleFormModal';
import { ZoneRule } from 'src/features/membershipType/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellZoneRulesActions({ row }: CellContext<ZoneRule, unknown>) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-block">
                            <UpdateZoneRuleFormModal selectedZoneRule={row.original}>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                </Button>
                            </UpdateZoneRuleFormModal>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-56">
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span className="inline-block">
                            <DeleteZoneRule selectedZoneRule={row.original}>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                </Button>
                            </DeleteZoneRule>
                        </span>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-56">
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
